import React from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  Box,
  List,
  ListItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();
  return (
    <Container sx={{ py: 5 }}>
      <Grid container spacing={3}>
        {/* Title */}
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Services
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item xs={12}>
          <Typography variant="body1">
            Safe Place offers a range of pre-employment screening for
            recruitment purposes. Find out about your new recruit’s background
            through our vast database. Choose one of the packages below:
          </Typography>
        </Grid>

        {/* Package 1 */}
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              p: 2,
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{
                mb: 2,
                height: "50px",
                width: "220px",
                color: "#ffff",
                fontWeight: 600,
                background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                "&:hover": {
                  background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                },
              }}
              onClick={() => navigate("/login")}
            >
              Basic
            </Button>
            <List sx={{ textAlign: "center", display: "inline-block" }}>
              <ListItem>Identify Check</ListItem>
              <ListItem>Address Check</ListItem>
              <ListItem>References Check</ListItem>
            </List>
          </Box>
        </Grid>

        {/* Package 2 */}
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              p: 2,
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{
                mb: 2,
                height: "50px",
                width: "220px",
                color: "#ffff",
                fontWeight: 600,
                background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                "&:hover": {
                  background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                },
              }}
              onClick={() => navigate("/login")}
            >
              Enhanced
            </Button>
            <List sx={{ textAlign: "center", display: "inline-block" }}>
              <ListItem>Identify Check</ListItem>
              <ListItem>Address Check</ListItem>
              <ListItem>References Check</ListItem>
              <ListItem>Previous Employer Check</ListItem>
            </List>
          </Box>
        </Grid>

        {/* Package 3 */}
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              p: 2,
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{
                mb: 2,
                height: "50px",
                width: "220px",
                color: "#ffff",
                fontWeight: 600,
                background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                "&:hover": {
                  background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                },
              }}
              onClick={() => navigate("/login")}
            >
              Comprehensive
            </Button>
            <List sx={{ textAlign: "center", display: "inline-block" }}>
              <ListItem>Identify Check</ListItem>
              <ListItem>Address Check</ListItem>
              <ListItem>References Check</ListItem>
              <ListItem>Previous Employer Check</ListItem>
              <ListItem>Education Check</ListItem>
            </List>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Services;
